import { Box, useTheme } from "@mui/material";
import type { StructuredExtractedFields as StructuredExtractedFieldsData } from "@/modules/zoom-calls/types";
import RequirementCard from "./requirement-card";

const StructuredExtractedFields = ({
  data,
}: {
  data: StructuredExtractedFieldsData;
}) => {
  const theme = useTheme();
  const requirements = Array.isArray(data.requirements)
    ? data.requirements
    : [];

  // No requirements captured → render nothing rather than an empty-state line.
  if (requirements.length === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: theme.nawy.spacing.sm,
      }}
    >
      {requirements.map((requirement, i) => (
        <RequirementCard key={i} requirement={requirement} index={i} />
      ))}
    </Box>
  );
};

export default StructuredExtractedFields;
